<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-toolbar-title>Abonnement Verlengen</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>1</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 1 - Abonnement gegevens</v-list-tile-title>
						<v-list-tile-sub-title>Gelieve onderstaande gegevens in te vullen</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>

			<v-container class="item-group" v-if="loaded">
				<form @submit.prevent="submit">
					<validation-observer ref="validationObserver">
						<validation-provider name="Straat" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="street"
								:error-messages="errors[0]"
								label="Straat *"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Huisnummer" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="house_number"
								:error-messages="errors[0]"
								label="Huisnummer *"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Postcode" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="postcode"
								:error-messages="errors[0]"
								label="Postcode *"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Plaats" rules="required" v-slot="{ errors }" slim>
							<v-text-field
								v-model="city"
								:error-messages="errors[0]"
								label="Plaats *"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
						<validation-provider name="Land" rules="required" v-slot="{ errors }" slim>
							<v-select
								v-model="country"
								:items="countries"
								:error-messages="errors[0]"
								label="Land *"
								required box hide-details
								class="mb-2"
								>
							</v-select>
						</validation-provider>
						<validation-provider name="Bedrijfsnaam" rules="" v-slot="{ errors }" slim>
							<v-text-field
								v-model="company_name"
								:error-messages="errors[0]"
								label="Bedrijfsnaam"
								required box hide-details
								class="mb-2"
							></v-text-field>
						</validation-provider>
					</validation-observer>
				</form>
			</v-container>

			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>2</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Welk abonnement wil je afsluiten?</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>

			<v-container class="item-group" v-if="loaded">
				<p class="text--lighten-1 text-sm-center px-5 pb-2">
					<a href="https://e-finder.com" target="_blank" class="text--black">Kijk voor meer informatie over de abonmenten op onze website.</a>
				</p>

				<v-alert
					:value="paymentFailed"
					type="error"
					outline
					class="mb-4"
				>
					Betaling niet gelukt.
				</v-alert>

				<v-radio-group v-model="selectedProductId" class="my-0 py-0">
					<v-list three-line class="mb-0 py-0">
						<v-list-tile avatar v-for="product in products" :key="product.key" class="mb-2 product-tile" :class="{'is-highlight': product.key == 'basic'}" @click="selectedProductId = product.id">
							<v-list-tile-avatar style="text-align: center">
								<v-radio :value="product.id" class="ma-0" :ripple="false"></v-radio>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title class="font-weight-medium">
									{{ product.name }}
									<span v-if="product.key == 'basic'"> - </span>
									<small v-if="product.key == 'basic'" class="green--text">meest gekozen</small>
								</v-list-tile-title>
								<v-list-tile-sub-title v-html="product.description"></v-list-tile-sub-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-flex class="text-xs-right">
									<strong>{{ (product.price / 12) * .01 | currency }}</strong><br/>
									<small>per maand</small>
								</v-flex>
							</v-list-tile-action>
						</v-list-tile>
					</v-list>
				</v-radio-group>

				<div align="center" class="mb-5">
					<p class="mb-4">Verleng nu en ontvang de eerste maand gratis!</p>
					<p class="text-discount">Totaal bedrag: {{ selectedProduct.price * 0.01 | currency }}</p>
					<h2>Totaal bedrag: {{ selectedProduct.price * 0.01 - (selectedProduct.price / 12) * .01 | currency }}</h2>
					<p class="mb-2 grey--text">Abonnementen worden per jaar vooraf betaald</p>
				</div>

				<v-btn type="submit"
					   @click.prevent="submit"
					   :loading="processingSubmission"
					   block dark depressed large
					   color="primary">Betalen
				</v-btn>
			</v-container>
		</v-content>
	</div>
</template>

<script>
	import SubscriptionService from "../../services/SubscriptionService";
	import {ValidationObserver, ValidationProvider} from "vee-validate";

	export default {
		components: { ValidationProvider, ValidationObserver },
		computed: {
			products() {
				return this.$store.state.products.products;
			},
			selectedProduct(){
				return this.products.find(product => product.id === this.selectedProductId);
			}
		},
		data() {
			return {
				processingSubmission: false,
				loaded: false,
				paymentFailed: false,
				selectedProductId: null,
				data: this.$route.query.data,
				token: this.$route.query.token,
				expires: this.$route.query.expires,
				street: '',
				house_number: '',
				postcode: '',
				city: '',
				country: '',
				company_name: '',
				countries: [
					"Nederland",
					"Luxemburg",
					"België",
					"Duitsland",
					"Verenigd Koninkrijk",
				]
			}
		},
    	methods: {
			async submit() {
				const valid = await this.$refs.validationObserver.validate();
				if (!valid) return window.scrollTo(0, 0);

				this.processingSubmission = true;
				this.paymentFailed = false;

				const payload = {
					product: this.selectedProductId,
					street: this.street,
					house_number: this.house_number,
					postcode: this.postcode,
					city: this.city,
					county: this.country,
					company_name: this.company_name
				};

				try {
					const response = await SubscriptionService.renew(this.token, this.data, this.expires, payload);
					this.processingSubmission = false;
					window.location = response.url;
				} catch (e) {
					this.processingSubmission = false;
					this.paymentFailed = true;
				}
			},
			isRunningInBrowser() {
				return process.env.CORDOVA_PLATFORM === 'browser'
			},
			urlParams() {
				return new URLSearchParams(window.location.search);
			},
			loadProducts() {
				this.$store.dispatch('products/loadProducts')
					.then(() => {
						// Select first product
						this.loaded = true;

						let product = null;
						if(product = this.products.find(product => product.key == 'basic')){
							this.selectedProductId = product.id;
						}else if (this.products[0]) {
							this.selectedProductId = this.products[0].id;
						}
					});
			}
		},
		created() {
			this.loadProducts();
			this.paymentFailed = (this.urlParams().get('failed') == 1);
		}
	}
</script>

<style lang="stylus">
	.text-discount
		text-decoration: line-through
		font-weight: bold
		margin-bottom: 0
		font-size: 1rem
		color: #cc0000

	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd

	.product-tile
		background-color: #fff
		border: solid 1px #dedede
		border-radius: .5rem

	.v-list__tile__avatar
		margin-top: 0

	.product-tile.is-highlight
		border: solid 1px #4CAF50
		background-color: rgba(#E8F5E9, .5)
		transition: background-color .2s

		&:hover
			background-color: #E8F5E9

		&:hover > .v-list__tile.theme--light
			background-color: transparent

</style>
